// extracted by mini-css-extract-plugin
module.exports = {"wrapper-page":"style_wrapper-page__3l4oW","form-control":"style_form-control__1dKnT","logo-lg":"style_logo-lg__3reul"};